import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categoriesAPI } from '../services/api';
import {
  Sparkles, Hammer, Wrench, Zap, Paintbrush, Leaf,
  Truck, Baby, Monitor, GraduationCap, AirVent, HeartHandshake,
  ChevronLeft, ChevronRight
} from 'lucide-react';

const iconMap = {
  Sparkles, Hammer, Wrench, Zap, Paintbrush, Leaf,
  Truck, Baby, Monitor, GraduationCap, AirVent, HeartHandshake,
};

const Categories = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    categoriesAPI.getAll().then(res => setCategories(res.data)).catch(() => {});
  }, []);

  const scroll = (dir) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: dir === 'left' ? -200 : 200,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="relative -mt-14 z-20 px-4">
      <div className="max-w-5xl mx-auto">
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 px-4 py-5 md:px-6">
          <div className="relative">
            {/* Scroll Left */}
            <button
              onClick={() => scroll('left')}
              className="absolute -left-3 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-white rounded-full shadow-md flex items-center justify-center hover:bg-gray-50 transition-colors hidden md:flex"
            >
              <ChevronLeft size={16} className="text-gray-600" />
            </button>

            {/* Categories Row */}
            <div
              ref={scrollRef}
              className="flex gap-2 sm:gap-4 overflow-x-auto scrollbar-hide px-2"
              style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            >
              {categories.map((cat) => {
                const IconComponent = iconMap[cat.icon];
                return (
                  <button
                    key={cat.id}
                    onClick={() => navigate(`/category/${cat.id}`)}
                    className="flex flex-col items-center gap-2 min-w-[72px] sm:min-w-[80px] py-2 px-1 rounded-xl hover:bg-gray-50 transition-colors group"
                  >
                    <div className="w-10 h-10 flex items-center justify-center text-gray-500 group-hover:text-blue-500 transition-colors">
                      {IconComponent && <IconComponent size={24} strokeWidth={1.5} />}
                    </div>
                    <span className="text-xs font-medium text-gray-600 group-hover:text-blue-500 transition-colors text-center whitespace-nowrap">
                      {t(`categoryNames.${cat.id}`, cat.name)}
                    </span>
                  </button>
                );
              })}
            </div>

            {/* Scroll Right */}
            <button
              onClick={() => scroll('right')}
              className="absolute -right-3 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-white rounded-full shadow-md flex items-center justify-center hover:bg-gray-50 transition-colors hidden md:flex"
            >
              <ChevronRight size={16} className="text-gray-600" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Categories;
